import {
  TRAILER_TAIL_TYPE_ALL,
  TRAILER_TAIL_TYPE_GET,
  TRAILER_TAIL_TYPE_POST,
  TRAILER_TAIL_TYPE_PUT,
  TRAILER_TAIL_TYPE_DEL,
  TRAILER_TAIL_TYPE_LOADING,
  TRAILER_TAIL_TYPE_ERROR,
} from '../../actions/types';

const initialState = {
  trailerTailType: null,
  isLoading: true,
  isCompleted: true,
};

// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case TRAILER_TAIL_TYPE_LOADING:
      return { isLoading: true, isCompleted: true };
    case TRAILER_TAIL_TYPE_ERROR:
      return { isLoading: false, isCompleted: false };
    case TRAILER_TAIL_TYPE_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case TRAILER_TAIL_TYPE_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case TRAILER_TAIL_TYPE_POST:
      return { isLoading: false, isCompleted: true };
    case TRAILER_TAIL_TYPE_PUT:
      return { isLoading: false, isCompleted: true };
    case TRAILER_TAIL_TYPE_DEL:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
